import { createContext, useContext } from 'react';

const PageSupportsLocaleContext = createContext(false);

export const PageSupportsLocaleProvider = PageSupportsLocaleContext.Provider;

export function usePageSupportsLocale(): boolean {
  return useContext(PageSupportsLocaleContext);
}
